import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Alert, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Switch, IconButton } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';

function UserManagementPage() {
    const { token } = useAuth();
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [search, setSearch] = useState('');

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(`/api/admin/users?search=${search}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setUsers(data);
        } catch (err) {
            setError('Failed to fetch users.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [token]);

    const handleUpdateUser = async (id, field, value) => {
        try {
            await axios.patch(`/api/admin/users/${id}`, { [field]: value }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setUsers(users.map(user => user._id === id ? { ...user, [field]: value } : user));
        } catch (err) {
            setError('Failed to update user.');
        }
    };

    return (
        <AdminLayout>
            <Typography variant="h4" gutterBottom>User Management</Typography>
            <TextField label="Search by username or email" value={search} onChange={(e) => setSearch(e.target.value)} onBlur={fetchUsers} fullWidth sx={{ mb: 2 }} />
            {error && <Alert severity="error">{error}</Alert>}
            {loading ? <CircularProgress /> : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Username</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Is Admin</TableCell>
                                <TableCell>Is Blocked</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {users.map((user) => (
                                <TableRow key={user._id}>
                                    <TableCell>{user.username}</TableCell>
                                    <TableCell>{user.email}</TableCell>
                                    <TableCell>
                                        <Switch checked={user.isAdmin || false} onChange={(e) => handleUpdateUser(user._id, 'isAdmin', e.target.checked)} />
                                    </TableCell>
                                    <TableCell>
                                        <Switch checked={user.isBlocked || false} onChange={(e) => handleUpdateUser(user._id, 'isBlocked', e.target.checked)} color="error" />
                                    </TableCell>
                                    <TableCell>
                                        <IconButton onClick={() => navigate(`/admin/users/${user._id}`)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </AdminLayout>
    );
}

export default UserManagementPage;
